import styled from "styled-components";

export const Footer = () => {

const Container = styled.div`
    width:100%;
    height:50vw;
   
    font-size: 2rem;
`;
    return (
        <>
            <Container>
                
            </Container>
        </>
    );
};